import { Component, OnInit } from '@angular/core'

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[lin-layout-form]',
  template: ` <ng-content></ng-content> `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        padding: 24px;
        margin-bottom: 24px;
      }
    `,
  ],
  standalone: false,
})
export class FormComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
